import React from 'react'
import { Link as RouterLink, LinkProps } from 'react-router-dom'

import { Routes } from '../../routes/routes'
import { Dictionary } from '../../utils/types'
import { useLinkGenerator } from '../../hooks/useLinkGenerator'

export type LinkP = {
  children: React.ReactNode
  className?: string
  to: Routes | string
  withoutTranslation?: boolean
  params?: Dictionary<React.ReactText>
  query?: Dictionary<string>
} & LinkProps

export const Link = ({ children, className, to, withoutTranslation, params, query, ...rest }: LinkP) => {
  const { generateRoute } = useLinkGenerator()

  return (
    <RouterLink {...rest} className={className} to={generateRoute(to, params, withoutTranslation, query)}>
      {children}
    </RouterLink>
  )
}
